import Vue from 'vue';
import Axios from 'axios';
import { tryShowLoading, tryHideLoading } from '@/api/loading';

//baseUrl到config/setting中配置
Axios.defaults.withCredentials = true;
Axios.defaults.baseURL = baseUrl;

// 请求拦截
Axios.interceptors.request.use(config => {
    let account = {};
    try {
        account = JSON.parse(window.localStorage.getItem("AccountInfo"));
    } catch (error) {
    }
    let token = (account && account.token) ? account.token : "";
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.ClientId = Vue.prototype.getBrowserClientId();
    config.headers.LoginType = process.env.SYSTEM_CODE + "_" + 'web';
    config.headers.CID = (account && account.company && account.company.c_id) ? account.company.c_id : 0;
    tryShowLoading(config);
    return config;
}, err => {
    tryHideLoading(err.config);
    return Promise.resolve(err);
})

// 响应拦截
Axios.interceptors.response.use(res => {
    tryHideLoading(res.config)
    return Promise.resolve(res);
}, err => {
    tryHideLoading(err.config);
    return Promise.reject(err);
})

const DECODE = {
    CODE_INVALID: 401,//失效
    CODE_OK: 0,//成功
    CODE_FAIL: 1//失败
}

//退出登录
function logout() {
    window.location.href = `${window.location.origin}/login.html?t=${new Date().getTime().toString(16)}`;
}

function funcThen(response, resolve, reject) {
    var res = response.data;
    if (res.code == DECODE.CODE_INVALID) {//失效
        logout();
        console.log(res.msg ? res.msg : res);
        reject(res);
    } else if (res.code == DECODE.CODE_OK) {//成功
        resolve(res);
    } else {//其他返回失败
        console.log(res.msg ? res.msg : res);
        reject(res);
    }
}

function funcCatch(err, reject) {
    var res = { error: err };
    console.log(err);
    if (err.response && err.response.data) {
        res = err.response.data
    }
    if (res.code == DECODE.CODE_INVALID) {//失效
        window.localStorage.removeItem('AccountInfo')
        logout();
        reject(res);
        return;
    }
    if (!res.msg) res.msg = err.message;
    reject(res)
}

export function z_geturl(url) {
    if (url.indexOf('access/') == 0) {
        return baseAccessUrl + url.replace('access/', '');
    } else if (url.indexOf('sys/') == 0) {
        return baseSysUrl + url.replace('sys/', '');
    } else if (url.indexOf('api/') == 0) {
        return baseUrl + url;
    }
    return url;
}

/**
 * 封装get方法 get请求无data，只能使用params。若要传递集合，可尝试post请求
 * 注：data:添加到请求体（Request body）中的，主要是object/array等集合数据；params:添加到url的请求字符串中，主要是int/string/bool等。params一般在config中
 * @param url 
 * @param params 
 * @returns {Promise} 
 */
export function z_get(url, params = {}, config = {}) {
    url = z_geturl(url);
    config.params = params;
    return new Promise((resolve, reject) => {
        Axios.get(url, config)
            .then(response => funcThen(response, resolve, reject))
            .catch(err => funcCatch(err, reject))
    })
}

/**
 * 封装post请求 
 * @param url
 * @param data
 * @returns {Promise}
 */
export function z_post(url, data = {}, config = {}) {
    url = z_geturl(url);
    return new Promise((resolve, reject) => {
        Axios.post(url, data, config)
            .then(response => funcThen(response, resolve, reject))
            .catch(err => funcCatch(err, reject))
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function z_patch(url, data = {}, config = {}) {
    url = z_geturl(url);
    return new Promise((resolve, reject) => {
        Axios.patch(url, data, config)
            .then(response => funcThen(response, resolve, reject))
            .catch(err => funcCatch(err, reject))
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function z_put(url, data = {}, config = {}) {
    url = z_geturl(url);
    return new Promise((resolve, reject) => {
        Axios.put(url, data, config)
            .then(response => funcThen(response, resolve, reject))
            .catch(err => funcCatch(err, reject))
    })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function z_delete(url, data = {}, config = {}) {
    url = z_geturl(url);
    config.data = data;
    return new Promise((resolve, reject) => {
        Axios.delete(url, config)
            .then(response => funcThen(response, resolve, reject))
            .catch(err => funcCatch(err, reject))
    })
}
